module.exports = __webpack_public_path__ + "img/logo-netflix.cfdcf83a.svg";